import type { ReactNode } from 'react';
import { Plus } from 'lucide-react';
import { Button } from '~/components/ui/buttons/Button';
import { SectionPanel } from '~/components/ui/SectionPanel';
import { Table, type TableColumn, type TableRow } from '~/components/ui/table';
import type { useTable } from '~/components/ui/table';

interface OrganizationUsersCardProps {
  title: string;
  addLabel: string;
  onAdd: () => void;
  columns: TableColumn[];
  rows: TableRow[];
  tableControls: ReturnType<typeof useTable>;
  emptyMessage: string;
  tableName: string;
  headerActions?: ReactNode;
}

export default function OrganizationUsersCard({
  title,
  addLabel,
  onAdd,
  columns,
  rows,
  tableControls,
  emptyMessage,
  tableName,
  headerActions,
}: Readonly<OrganizationUsersCardProps>) {
  return (
    <SectionPanel
      title={title}
      aside={
        <div className="flex items-center gap-2">
          {headerActions}
          <Button size="sm" width="auto" onClick={onAdd}>
            <Plus size={16} className="mr-1" />
            {addLabel}
          </Button>
        </div>
      }
      bodyClassName="pt-4"
    >
      <Table
        minWidth={40}
        rows={rows}
        columns={columns}
        tableControls={tableControls}
        emptyMessage={emptyMessage}
        name={tableName}
      />
    </SectionPanel>
  );
}
